export const B2B_CPD_CONSULTATION = 'b2b_cpd_consultation';
export const EXPERIMENTS: string[] = [B2B_CPD_CONSULTATION];
